import React from 'react'
import PropTypes from 'prop-types'

const WPArticle = props => {
  return (
    <article className={`wp-article ${props.className || ''}`} style={props.style}>
      {props.content ? <div dangerouslySetInnerHTML={{ __html: props.content }} /> : props.children}
    </article>
  )
}

WPArticle.defaultProps = {
  style: {}
}

WPArticle.propTypes = {
  content: PropTypes.string,
  style: PropTypes.object
}

export default WPArticle
